import React from 'react';
import {
    ApplianceOvenAndMicrowave,
    ApplianceProps,
} from 'shared/components/Forms/ApplianceOvenAndMicrowave';
import {Appliance as Rangehood} from 'components/customer/Product/Appliance';
import {RANGEHOOD} from 'components/customer/Product/store/productApi';

const APPLIANCE_TYPES: {[key: string]: number} = {
    oven: 0,
    rangehood: 1,
    microwave: 2,
};

export const Appliance = (props: ApplianceProps) => {
    const {field} = props;
    const type = APPLIANCE_TYPES[field.options.applianceType];

    if (type == RANGEHOOD) {
        return <Rangehood type={type} field={field} />;
    } else {
        return <ApplianceOvenAndMicrowave {...props} />;
    }
};
